import { ThemeResource } from "./resources";

export function getTheme({ themeId }) {
  return ThemeResource.get({ themeId });
}
